import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import BookingSuccess from "@/pages/BookingSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ChatReply from "@/pages/ChatReply";
import { PrivacyPolicy, TermsOfService, RefundPolicy } from "@/pages/Legal";
import Rewards from "@/pages/Rewards";
import Gift from "@/pages/Gift";
import ChatWidget from "@/components/ChatWidget";
import MobileCallButton from "@/components/MobileCallButton";
import WelcomePopup from "@/components/WelcomePopup";

function App() {
    return (
        <div className="App">
            <Toaster
                position="top-center"
                theme="light"
                toastOptions={{
                    style: {
                        background: "#0B1B3B",
                        color: "#F5EFE2",
                        border: "1px solid #D4AF37",
                        fontFamily: "Outfit, sans-serif",
                    },
                }}
            />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/book" element={<Booking />} />
                    <Route path="/booking/success/:id" element={<BookingSuccess />} />
                    <Route path="/admin" element={<AdminLogin />} />
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    <Route path="/reply/:token" element={<ChatReply />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/refund-policy" element={<RefundPolicy />} />
                    <Route path="/rewards" element={<Rewards />} />
                    <Route path="/gift" element={<Gift />} />
                </Routes>
            </BrowserRouter>
            <ChatWidget />
            <MobileCallButton />
            <WelcomePopup />
        </div>
    );
}

export default App;
